<div class="progress-outer">
  <div *ngIf="progress>=0" class="progress-inner" [style.width]="progress + '%'">
    {{progress}}%
  </div>
  <div *ngIf="progress==-1" class="progress-inner" [style.width]="100 + '%'">
    Loading...
  </div>
</div>